function pick(...keys) {
  return (obj) => {
    const result = /* @__PURE__ */ Object.create(null);
    for (const key of keys) {
      result[key] = obj[key];
    }
    return result;
  };
}
export {
  pick
};
//# sourceMappingURL=pick.js.map
